module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_110_25.818560bc.pdf";